import Rails from '@rails/ujs'
import debounce from 'lodash.debounce'
import { useDispatch } from 'stimulus-use'
import { useBusItem } from '@app/javascript/controllers/mixins/useBusItem.js'
import ApplicationController from '@app/javascript/controllers/application_controller'

export class Controller extends ApplicationController {
  static targets = [
    'renderedFilters',
    'filter'
  ]

  static values = {
    skip: Array,
    reloaded: Boolean
  }

  doConnect() {
    useBusItem(this)
    useDispatch(this)

    this.reloadContentTypeFilters = debounce(this.reloadContentTypeFilters, 1000, { leading: false })
  }

  afterConnect() {
    if (this.reloadedValue) {
      this.dispatch('reloaded', { paramsObj: this.searchParams })
    }
  }

  reloadContentTypeFilters(reusedFilters) {
    this.removeStaleFiltersFromScreen(reusedFilters)
    this.fetchContentTypeFilters()
  }

  removeStaleFiltersFromScreen(reusedFilters) {
    const clearAllFilters = !reusedFilters || reusedFilters.length === 0

    if (clearAllFilters) {
      this.renderedFiltersTarget.innerHTML = ''
      return
    }

    // ... otherwise cherry pick and keep the ones that should be reused
    this.filterTargets.forEach((filterElem) => {
      const filterName = filterElem.getAttribute('data-name')
      const keepFilter = reusedFilters.includes(filterName)

      if (!keepFilter) filterElem.remove()
    })
  }

  fetchContentTypeFilters() {
    const params = { ...this.searchParams, skip: this.skipValue }

    Rails.ajax({
      type: 'GET',
      url: '/search/content_type_filters',
      dataType: 'script',
      data: $.param(params)
    })
  }

  get searchParams() {
    return this.getBusItem('search-v2--container').getCurrentSearchParams()
  }
}
